import axios from '@/common/axios'

const BASE_URL = '/api/media_schedules'

export function getMediaSchedules(params) {
  return axios.get(BASE_URL, { params })
}

export function createMediaSchedule(data) {
  return axios.post(BASE_URL, data)
}

export function deleteMediaSchedule(id) {
  return axios.delete(`${BASE_URL}/${id}`)
}

// Lazy-loads schedule media for a date window (max 90 days server-side).
export function getScheduleMedia(id, params) {
  return axios.get(`${BASE_URL}/${id}/media`, { params })
}
